import Token from './token';
import getTokenTypeByToken from './get-token-type-by-token';

export const cleanupTokens = tokens => {
    tokens = flattenInlineTokens(tokens);
    tokens.forEach(token => {
        token.type = getTokenTypeByToken(token);

        // set image and hardbreak to block elements
        if (token.type === 'image' || token.type === 'hardbreak') {
            token.block = true;
        }
    });

    /**
     * changing a link token to a blocklink to fix issue where link tokens with
     * nested non text tokens breaks component
     */
    const stack = [];
    tokens = tokens.reduce((acc, token, index) => {
        if (token.type === 'link' && token.nesting === 1) {
            stack.push(token);
        } else if (stack.length > 0 && token.type === 'link' && token.nesting === -1) {
            if (stack.some(stackToken => stackToken.block)) {
                stack[0].type = 'blocklink';
                stack[0].block = true;
                token.type = 'blocklink';
                token.block = true;
            }

            stack.push(token);

            while (stack.length) {
                acc.push(stack.shift());
            }
        } else if (stack.length > 0) {
            stack.push(token);
        } else {
            acc.push(token);
        }

        return acc;
    }, []);

    return tokens;
}

export const groupTextTokens = tokens => {
    const result = [];

    let hasGroup = false;
    tokens.forEach((token, index) => {
        if (!token.block && !hasGroup) {
            hasGroup = true;
            result.push(new Token('textgroup', 1));
            result.push(token);
        } else if (!token.block && hasGroup) {
            result.push(token);
        } else if (token.block && hasGroup) {
            hasGroup = false;
            result.push(new Token('textgroup', -1));
            result.push(token);
        } else {
            result.push(token);
        }
    });

    return result;
}

let uuid = new Date().getTime();

export const getUniqueID = () => {
    uuid++;

    return `rnmr_${uuid.toString(16)}`;
}

export const flattenInlineTokens = tokens => {
    return tokens.reduce((acc, curr) => {
        if (curr.type === 'inline' && curr.children && curr.children.length > 0) {
            const children = flattenInlineTokens(curr.children);
            while (children.length) {
                acc.push(children.shift());
            }
        } else {
            acc.push(curr);
        }

        return acc;
    }, []);
}

export const escapeRegExp = string => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const escapeCode = (source, modifier, replaceNewLines) => {
    const escCodeMatches = [];
    const codeMatches = [];

    const espacedSource = source
        .replace(/(\\`+)/g, escCode => {
            escCode = replaceNewLines ? escCode.replace(/"/g, '\\"').replace(/\n/g, '\\n') : escCode;
            escCodeMatches.push(escCode);

            return '%NIFTY_ESC_CODE_REPLACER%';
        })
        .replace(/(`+(?=[^]+`)[^]+?`+)/g, code => {
            code = replaceNewLines ? code.replace(/"/g, '\\"').replace(/\n/g, '\\n') : code;
            codeMatches.push(code);

            return '%NIFTY_CODE_REPLACER%';
        });

    return modifier(espacedSource)
        .replace(/%NIFTY_CODE_REPLACER%/g, match => codeMatches.shift())
        .replace(/%NIFTY_ESC_CODE_REPLACER%/g, match => escCodeMatches.shift());
}
